import type { Rule } from 'antd/es/form';
import { FormattedMessage } from '@/components/formatted_message/FormattedMessage';
import { COMMON_FORM_ERRORS_TRANSLATED } from '@/common/messages/form/errors';
import { USER_NAME_MAX_LENGTH } from '@enmon/commons/lib/enmon';

// 5-15 digits (E.164 max), optional +/00 prefix, separators allowed between digits.
// Surrounding whitespace is tolerated because the value is trimmed on submit.
// Whitespace- or separator-only input does not match.
export const phoneRegExp = /^\s*(?:\+|00)?(?:[\s()./-]*\d){5,15}[\s()./-]*$/;

export const phoneNumberRule: Rule = {
  pattern: phoneRegExp,
  message: <FormattedMessage {...COMMON_FORM_ERRORS_TRANSLATED.phone} />,
};

export const userNameMaxLengthRule: Rule = {
  max: USER_NAME_MAX_LENGTH,
  message: <FormattedMessage {...COMMON_FORM_ERRORS_TRANSLATED.maxLength} values={{ max: USER_NAME_MAX_LENGTH }} />,
};

/** Required text field that also rejects whitespace-only input. ENMON-3876. */
export const requiredTextRule: Rule = { required: true, whitespace: true };
